import React from "react";
import PackageDetailsWrap from "./PackageDetailsWrap";

function OnsiteWorkshop(props) {
  const { item_id } = props.match.params;
  return (
    <>
      <PackageDetailsWrap item_id={item_id} ctype="onsite" />
    </>
  )
}

export default OnsiteWorkshop
